export default __webpack_public_path__ + "static/media/airback.6bcfe29a.png";